import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from "@shared/services/dialog-service";
import { SpreadsheetState } from '../store/spreadsheet.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';


@Injectable({
  providedIn: 'root',
})

export class ShareWorkbookSetCommandHandler implements IPlatformCommandHandler {
  currentWorkbookId: string;
  constructor(
    protected dialogService: DialogService,
    private fileStoreCommonService: FileStoreCommonService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const workbookSetId = command.fieldValues['WorkbookSetId'];
    this.fileStoreCommonService.openShareDialogById(workbookSetId);
    return true;
  }
}
